
import { select } from 'd3-selection';

import { getBasalTitleAccessor, getBolusTitleAccessor, getCarbTitleAccessor } from './DayInfoGraph';
import { idKey } from '../utils/dataUtils';
import { parseDate } from '../utils/formats';
import './Dashboard.css';

const treatmentMaxHeight = 150; // 350 / 2

function render(selection) {
  const {
    basal,
    bolus,
    bolusExtent,
    carbExtent,
    day,
    formatTimeString,
    nutrition,
    t,
    timeScale,
  } = selection.datum();

  const date = parseDate(day);
  const timeObject = { time: date.toISOString() };
  const translateX = -timeScale(timeObject);

  const treatmentBarWidth = 16;

  const basalTitleAccessor = getBasalTitleAccessor({ formatTimeString, t });
  const bolusTitleAccessor = getBolusTitleAccessor({ formatTimeString, t });
  const carbTitleAccessor = getCarbTitleAccessor({ formatTimeString, t });

  const svg = select(selection.node().ownerSVGElement);
  const defs = svg.select('defs');
  const clipPathId = defs.select('.canvasClip').node().id;

  const graphsG = selection
    .attr('clip-path', `url(#${clipPathId})`)
  .selectAll('g.graphs')
    .data([clipPathId], Object)
    .join('g')
    .attr('class', 'graphs')
    .attr('transform', `translate(${translateX},0)`)
    .style('visibility', clipPathId === 'canvasClip' ? 'hidden' : null);

  // This should be comparable to bolus treatments - in area!
  // So basal rate of 1 unit for 1 hour should have the same  area as 1 unit bolus treatment
  // 1 unit bolus = treatmentMaxHeight / bolusExtent * treatmentWidth
  // hour width = 720 / 24 = 30
  const basalUnitHeight = treatmentMaxHeight / bolusExtent[1] * treatmentBarWidth / 30;

  const basalG = graphsG.selectAll('g.basal').data([1]).join('g')
    .attr('class', 'basal');
  basalG.selectAll('rect').data(basal).join('rect')
    .attr('class', 'treatment')
    .attr('transform', d => `translate(${timeScale(d)},${350 - (d.rate * basalUnitHeight)})`)
    .attr('width', d => timeScale({ time: d.endTime }) - timeScale(d))
    .attr('height', d => (d.rate * basalUnitHeight))
  .append('title')
    .text(basalTitleAccessor);

  graphsG.selectAll('g.carbs').data(nutrition, idKey)
    .join(enter => {
      const e = enter.append('g')
        .attr('class', 'carbs')
        .attr('transform', d => `translate(${timeScale(d) - (treatmentBarWidth / 2)},0)`);
      e.append('rect')
        .attr('class', 'treatment')
        .attr('width', treatmentBarWidth)
        .attr('height', d => ((d.carbohydrate || 0) / carbExtent[1]) * treatmentMaxHeight)
      .append('title')
        .text(carbTitleAccessor);
      return e;
    },
    update => update,
    exit => {
      select(this).remove();
      return exit;
    });

  graphsG.selectAll('g.bolus').data(bolus, idKey)
    .join(enter => {
      const e = enter.append('g')
        .attr('class', 'bolus')
        .attr('transform', d => `translate(${timeScale(d) - (treatmentBarWidth / 2)},${350 - ((d.amount || 0)/ bolusExtent[1]) * treatmentMaxHeight})`);
      e.append('rect')
        .attr('class', 'treatment')
        .attr('width', treatmentBarWidth)
        .attr('height', d => ((d.amount || 0) / bolusExtent[1]) * treatmentMaxHeight)
      .append('title')
        .text(bolusTitleAccessor);
      return e;
    },
    update => update,
    exit => {
      select(this).remove();
      return exit;
    });
}

const TreatmentsOverlay = {
  init: f => f,
  render,
  destroy: f => f,
};

export default TreatmentsOverlay;